<template>
  <div
    class="mx-auto p-8 prose prose-sm prose-stone sm:prose-base w-full text-justify !text-black"
    v-html="htmlContent"
  />
</template>

<script>
import { marked } from 'marked'

import { mapState } from 'vuex'

import privacyPolicyEn from '@/markdown/privacy-policy-en.md?raw'
import privacyPolicyUk from '@/markdown/privacy-policy-uk.md?raw'

export default {
  name: 'PublicPrivacyPolicyPage',

  computed: {
    ...mapState('locale', ['currentLocale']),

    htmlContent() {
      const text =
        this.currentLocale === 'en' ? privacyPolicyEn : privacyPolicyUk

      return marked(text)
    }
  }
}
</script>
